export const environment: any = {
  production: true,
  version: '202610020748',
  tag: '3.7.49.0',
};
